import { Alert } from "@mui/material";
import React from "react";

const VEBDisclaimer = () => {
	return (
		<div className="disclaimer-container">
			<Alert severity="warning" sx={{ fontSize: "1rem" }}>
				<div className="veb-disclaimer-message">
					Disclaimer:{" "}
					<strong className="disclaimer">
						After May 1, 2024, your current coverage will roll over to the New Plan Year with no changes.
					</strong>
				</div>
			</Alert>
		</div>
	);
};

export default VEBDisclaimer;
